export default function uploadAdherenceLogo() {

    if ('undefined' === typeof( jQuery('#logo-file')[0].files[0] )) {
        alert('Select a file!');
        return;
    }
    var blnValid = false;
    var fileName = jQuery('#logo-file').val().split('\\').pop();
    var validFileExtensions = [".jpg", ".jpeg", ".gif", ".png"];

    for (var j = 0; j < validFileExtensions.length; j++) {
        var sCurExtension = validFileExtensions[j].toLowerCase(),
            fName = fileName.toLowerCase();
        if ( fName.includes( sCurExtension ) ) {
            blnValid = true;
            break;
        }
    }

    if (!blnValid) {
        $('#upload-logo-response').addClass('alert alert-danger').text("Sorry, " + fileName + " is invalid, allowed extensions are: " + validFileExtensions.join(", "));
        return false;
    }

    // Grab the file from the input.
    var file = jQuery('#logo-file')[0].files[0];

    var formData = new FormData();
    formData.append('file', file);
    formData.append('folder', 'protocol-adherence');
    // Fire the request.
    jQuery.ajax({
        url: wpApiSettings.root + 'isda/v1/files',
        method: 'POST',
        folder: 'protocol-adherence',
        processData: false,
        contentType: false,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
        },
        data: formData
    }).success(function (response) {
        $('#adhering-org-logo-attachment').val(response.url);

        $('#logo-image').attr('src', response.full_url)
            .css({maxWidth: 200, maxHeight: 200});
        $('#upload-logo-response').removeClass().addClass('alert alert-success').text('Upload Completed');
    }).error(function (response) {
        $('#upload-logo-response').removeClass().addClass('alert alert-danger').text('Upload Failed');
    });
    
}